import React, { useState, useRef } from 'react';
import SectionHeader from './section-header';
import '../styles/video.scss';

// poster is a rendered image element (e.g. a <StaticImage />), since StaticImage can't take its src from a prop.
const Video = ({ heading, video, poster }) => {
    const videoRef = useRef(null);
    const [started, setStarted] = useState(false);
    const [playing, setPlaying] = useState(false);

    const togglePlay = () => {
        const video = videoRef.current;
        if (video.paused) {
            video.play();
            setStarted(true);
            setPlaying(true);
        } else {
            video.pause();
            setPlaying(false);
        }
    };

    const handleVideoEnd = () => {
        const video = videoRef.current;
        video.currentTime = 0;
        setPlaying(false);
        setStarted(false);
    };

    return (
        <section className={`ff video ${heading ? '' : 'article'}`} id="testimonial">
            {heading ? (
                <SectionHeader heading={heading} />
            ) : null}
            <div className={`video-container ${playing ? 'playing' : 'paused'} ${started ? 'started' : ''}`} onClick={togglePlay}>
                <video
                    ref={videoRef}
                    playsInline
                    preload="metadata"
                    onEnded={handleVideoEnd}>
                    <source src={video} type="video/mp4" />
                    <track kind="captions" srcLang="en" />
                </video>
                {poster ? (
                    <div className="poster">{poster}</div>
                ) : null}
                <button
                    type="button"
                    className="play-button"
                    aria-label={playing ? 'Pause video' : 'Play video'}
                    onClick={(e) => { e.stopPropagation(); togglePlay(); }}>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M6.5 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L8 4.64A1 1 0 0 0 6.5 5.5z" />
                    </svg>
                </button>
            </div>
        </section>
    )
};

export default Video
